import React, { useEffect } from 'react';
import GuestChooser from '../../components/guestDiscovery/GuestChooser';
import { posthog } from '../../main';
import { useSystemThemeWhenUnset } from '../../lib/theme/useSystemThemeWhenUnset';
import { useDiscoveryOrigin } from '../../lib/discovery/discoveryOrigin';
import './guestDiscoveryShared.css';

/** Deep-link shell; the mountable chooser also powers learner-home. */
function GuestChooserPage() {
  useSystemThemeWhenUnset(); // #3756: match the marketing site's OS dark mode
  useDiscoveryOrigin(); // records ?from= for /discover's back link
  useEffect(() => {
    // Explicit null distinguishes a direct/unattributed deep link from every
    // real surface value instead of relying on an omitted property.
    posthog?.capture?.('chooser_entered', { surface: null });
  }, []);

  return (
    <main className="gd-page gd-chooser-page" data-testid="gd-chooser-page">
      <GuestChooser />
    </main>
  );
}

export default GuestChooserPage;
